<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            Viewing Sales Order
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div
          class="bg-white p-1 rounded-[4px] flex items-center gap-[8px] md:gap-[16px] mt-[16px]"
        >
          <button
            :class="[
              'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px] outline-none focus:outline-none',
              {
                'bg-[#2463EB] text-white': activeTab === 'order',
                'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'order',
              },
            ]"
            @click="switchTab('order')"
          >
            Order Details
          </button>
          <button
            :class="[
              'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px] outline-none focus:outline-none',
              {
                'bg-[#2463EB] text-white': activeTab === 'payment',
                'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'payment',
              },
            ]"
            @click="switchTab('payment')"
          >
            Payment Received
          </button>
          <button
            :class="[
              'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px] outline-none focus:outline-none',
              {
                'bg-[#2463EB] text-white': activeTab === 'return',
                'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'return',
              },
            ]"
            @click="switchTab('return')"
          >
            Returned Stock
          </button>
        </div>

        <div v-if="activeTab == 'order'" class="mt-[16px]">
          <div
            class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
          >
            <div class="flex items-center gap-[16px] mt-[16px]">
              <div
                class="flex flex-col md:flex-row md:items-center justify-between w-full"
              >
                <p class="text-[20px] font-bold text-[#2463EB] leading-[20px]">
                  Order # {{ order.orderNumber }}
                </p>
                <div
                  class="flex mt-[10px] md:mt-0 md:items-center md:justify-end gap-[10px]"
                >
                  <div class="dropdown">
                    <button
                      class="bg-[#2463EB] border-[#2463EB] border-solid border-[1.5px] p-[8px] rounded-[8px] outline-none focus:outline-none flex items-center gap-[8px]"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <img src="/assets/icon/printer.svg" alt="" />

                      <span
                        class="text-[14px] text-white font-normal leading-[20px]"
                        >Print Invoice</span
                      >
                      <i class="fa-solid fa-chevron-down text-white"></i>
                    </button>
                    <ul
                      class="dropdown-menu shadow-none"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <li
                        @click="printPOSInvoice"
                        v-if="
                          user.type == 'Distributor' && user.role != 'Customer'
                        "
                        class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[10px] px-[16px]"
                      >
                        POS
                      </li>
                      <li
                        @click="printA4Invoice"
                        v-if="
                          user.type == 'Distributor' && user.role != 'Customer'
                        "
                        class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                      >
                        A4 Format
                      </li>
                    </ul>
                  </div>
                  <button
                    class="border-[#2463EB] border-[1.5px] border-solid p-[8px] rounded-[8px] outline-none focus:outline-none flex items-center gap-[8px]"
                    @click="viewSendInvoice"
                    v-if="user.type == 'Distributor' && user.role != 'Customer'"
                  >
                    <img src="/assets/icon/send-2.svg" alt="" />
                    <span
                      class="text-[14px] text-[#2463EB] font-normal leading-[20px]"
                      >send Invoice</span
                    >
                  </button>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Order for
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ order.maker ? order.maker.displayName : "" }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Phone Number
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{
                  order.maker.phoneNumber ? order.maker.phoneNumber : ""
                }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Email Address
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{
                  order.maker.emailAddress ? order.maker.emailAddress : ""
                }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Account Manager
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ order.parent.name }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Ledger Balance
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                :style="[
                  parseInt(order.maker.balance) <= 0
                    ? {
                        color: '#DC2828',
                        'font-size': '15px',
                        'font-weight': 'normal',
                      }
                    : {
                        color: '#28C76F',
                        'font-size': '15px',
                        'font-weight': 'normal',
                      },
                ]"
              >
                &#8358;{{ formatMoney(order.maker.balance) }}
              </span>
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Created By
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ orderedBy }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Created Date
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ formatDate(order.created) }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-center gap-[24px] mt-[24px] w-full"
            >
              <div class="max-w-[400px] w-full">
                <h2
                  class="font-medium text-[14px] text-[#353535] leading-[20px]"
                >
                  Order Date
                </h2>
                <span
                  class="font-normal text-[14px] text-[#353535] leadin-[24px] border-[1.5px] border-solid border-[#D0D5DD] px-[14px] py-[12px] w-full mt-[10px] rounded-[8px] block"
                >
                  {{
                    order.orderDate
                      ? formatDate(order.orderDate)
                      : formatDate(order.created)
                  }}</span
                >
              </div>
              <div class="max-w-[400px] w-full">
                <h2
                  class="font-medium text-[14px] text-[#353535] leading-[20px]"
                >
                  Delivery Address
                </h2>
                <span
                  class="font-normal text-[14px] text-[#353535] leadin-[24px] border-[1.5px] border-solid border-[#D0D5DD] px-[14px] py-[12px] w-full mt-[10px] rounded-[8px] block"
                  >{{ order.deliveryAddress }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
          >
            <h2
              class="text-[16px] font-bold leading-[20px] text-[#353535] mb-[16px]"
            >
              Order Details
            </h2>
            <div class="table-responsive" id="printing">
              <table class="table no-footer text-nowrap">
                <thead class="bg-[#ECF9FF]">
                  <tr>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Description
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Quantity
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Unit Price
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Sub Total
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Discount
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in order.details" :key="index">
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ item.code }} - {{ item.description }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ item.quantity }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      &#8358; {{ formatMoney(item.unitPrice) }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      &#8358;
                      {{ formatMoney(item.quantity * item.unitPrice) }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      &#8358; {{ formatMoney(item.discount.toFixed(2)) }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      &#8358;
                      {{
                        formatMoney(
                          item.quantity * item.unitPrice - item.discount
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="order.details.length">
                    <td colspan="4"></td>
                    <td class="text-right">
                      <span
                        class="font-medium text-[14px] leading-[20px] text-[#353535]"
                        >Subtotal</span
                      >
                    </td>
                    <td
                      class="text-[14px] leading-20px font-normal text-[#353535]"
                    >
                      &#8358; {{ formatMoney(order.subtotal) }}
                    </td>
                  </tr>
                  <tr v-if="order.details.length">
                    <td colspan="4"></td>
                    <td class="text-right">
                      <span
                        class="font-medium text-[14px] leading-[20px] text-[#353535]"
                        >Discount</span
                      >
                    </td>
                    <td
                      class="text-[14px] leading-20px font-normal text-[#353535]"
                    >
                      &#8358; {{ formatMoney(order.discount) }}
                    </td>
                  </tr>
                  <tr v-if="order.details.length">
                    <td colspan="4"></td>
                    <td class="text-right">
                      <span
                        class="font-medium text-[14px] leading-[20px] text-[#353535]"
                        >Total</span
                      >
                    </td>
                    <td
                      class="text-[14px] leading-20px font-normal text-[#353535]"
                    >
                      &#8358; {{ formatMoney(order.total) }}
                    </td>
                  </tr>
                  <tr v-if="order.details && !order.details.length">
                    <td colspan="12">
                      <div class="text-center">No items in order</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="activeTab == 'payment'">
          <div
            class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
          >
            <div
              class="flex flex-col md:flex-row md:items-center justify-between"
            >
              <h2
                class="text-[16px] font-bold leading-[20px] text-[#353535] mb-[16px]"
              >
                Payment Received
              </h2>
              <div class="flex md:items-center md:justify-end gap-[10px]">
                <div class="dropdown">
                  <button
                    class="bg-[#2463EB] border-[#2463EB] border-solid border-[1.5px] p-[8px] rounded-[8px] outline-none focus:outline-none flex items-center gap-[8px]"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img src="/assets/icon/printer.svg" alt="" />

                    <span
                      class="text-[14px] text-white font-normal leading-[20px]"
                      >Print Receipt</span
                    >
                    <i class="fa-solid fa-chevron-down text-white"></i>
                  </button>
                  <ul
                    class="dropdown-menu shadow-none"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li
                      @click="posReceipt"
                      v-if="
                        user.type == 'Distributor' && user.role != 'Customer'
                      "
                      class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[10px] px-[16px]"
                    >
                      POS
                    </li>
                    <li
                      @click="printReceipt"
                      v-if="
                        user.type == 'Distributor' && user.role != 'Customer'
                      "
                      class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                    >
                      A4 Format
                    </li>
                  </ul>
                </div>
                <button
                  class="border-[#2463EB] border-[1.5px] border-solid p-[8px] rounded-[8px] outline-none focus:outline-none flex items-center gap-[8px]"
                  @click="viewSendReceipt"
                  v-if="user.type == 'Distributor' && user.role != 'Customer'"
                >
                  <img src="/assets/icon/send-2.svg" alt="" />
                  <span
                    class="text-[14px] text-[#2463EB] font-normal leading-[20px]"
                    >send Receipt</span
                  >
                </button>
              </div>
            </div>
            <div class="flex items-center gap-[24px] mt-[24px] w-full">
              <div class="">
                <h2
                  class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
                >
                  Total Payment
                </h2>
                <span
                  class="font-medium text-[16px] text-[#353535] leading-[24px] py-[12px] w-full rounded-[8px] block"
                >
                  &#8358;{{ formatMoney(totalPayment) }}</span
                >
              </div>
              <div class="">
                <h2
                  class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
                >
                  Invoice balance
                </h2>
                <span
                  class="font-medium text-[16px] text-[#353535] leading-[24px] py-[12px] w-full rounded-[8px] block"
                >
                  &#8358;{{
                    formatMoney(
                      Number(Math.abs(order.total - totalPayment)).toFixed(2)
                    )
                  }}
                </span>
              </div>
            </div>
            <div class="table-responsive" id="printing">
              <table class="table no-footer text-nowrap">
                <thead class="bg-[#ECF9FF]">
                  <tr>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Value Date
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Amount
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Payment Channel
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Posted By
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Entry Date
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in order.paymentHistory"
                    :key="index"
                  >
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ formatDate(item.paymentDate) }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      &#8358;{{ formatMoney(item.paidAmount) }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{
                        item.paymentChannel
                          ? item.paymentChannel.paymentChannelTypeName
                          : "N/A"
                      }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ item.owner ? item.owner.displayName : "N/A" }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ formatDate(item.created) }}
                    </td>
                  </tr>
                  <tr v-if="!order.paymentHistory.length">
                    <td colspan="12">
                      <div class="text-center">No items in order</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="activeTab == 'return'">
          <div
            class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
          >
            <h2
              class="text-[16px] font-bold leading-[20px] text-[#353535] mb-[16px]"
            >
              Returned Stock
            </h2>
            <div class="table-responsive mt-[16px]" id="printing">
              <table class="table text-nowrap no-footer">
                <thead class="bg-[#ECF9FF]">
                  <tr>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Product Description
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Quantity Returned
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Unit Price
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Total Price
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Return Date
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Processed By
                    </th>
                    <th
                      class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                    >
                      Actiion
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in order.returnedStock" :key="index">
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ item.description }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ item.quantity }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ item.unitPrice }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ item.unitPrice * item.quantity }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ formatDate(item.returned) }}
                    </td>
                    <td
                      class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                    >
                      {{ item.createdBy }}
                    </td>
                    <td class="text-[14px] font-normal leading-[16.94px]">
                      <span
                        :class="[
                          'badge',
                          {
                            'badge-success':
                              actionsList.filter((x) => x.id === item.action)[0]
                                .label === 'Received',
                          },
                          {
                            'badge-warning':
                              actionsList.filter((x) => x.id === item.action)[0]
                                .label === 'Reversed',
                          },
                          {
                            'badge-danger':
                              actionsList.filter((x) => x.id === item.action)[0]
                                .label === 'Disposed',
                          },
                        ]"
                      >
                        <span
                          class="inline-block w-[10px] h-[10px] rounded-[1px]"
                          :style="{
                            backgroundColor:
                              actionsList.filter((x) => x.id === item.action)[0]
                                .label === 'Received'
                                ? '#16a249'
                                : actionsList.filter(
                                    (x) => x.id === item.action
                                  )[0].label === 'Disposed'
                                ? '#EF5253'
                                : '#FFA500',
                          }"
                        ></span>
                        <span class="text-[12px] font-normal">
                          {{
                            actionsList.filter((x) => x.id === item.action)[0]
                              .label
                          }}
                        </span>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="!order.returnedStock.length">
                    <td colspan="12">
                      <div class="text-center">No items in order</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";

export default {
  props: [
    "order",
    "activeTab",
    "closeModal",
    "switchTab",
    "systemSettings",
    "printPOSInvoice",
    "printA4Invoice",
    "viewSendInvoice",
    "actionsList",
    "viewSendReceipt",
    "printReceipt",
    "posReceipt",
  ],
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    orderedBy: function() {
      var n = "";
      if (this.user.role == "Customer") {
        if (this.order.maker) n = this.order.maker.displayName;
        else n = "NA";
      } else {
        if (this.order.introducer) n = this.order.introducer.displayName;
        else if (this.order.maker) n = this.order.maker.displayName;
        else n = "NA";
      }

      return n;
    },
    totalPayment: function() {
      var myTotal = 0;

      if (this.order.paymentHistory) {
        for (var i = 0, len = this.order.paymentHistory.length; i < len; i++) {
          myTotal += this.order.paymentHistory[i].paidAmount;
        }
      }

      return myTotal;
    },
    Ledger: function() {
      if (this.order && this.order.buyer && this.order.buyer.accountBalance) {
        return this.order.buyer.accountBalance;
      }
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },

    formatDateWithTime(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
  },
};
</script>
